// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRouteManifest"] = "{\"isrRoutes\":[],\"dynamicRoutes\":[],\"staticRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.1.6";import * as Sentry from '@sentry/nextjs';
import { browserTracingIntegration } from '@sentry/browser';

const SENTRY_DSN = process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN;

Sentry.init({
  dsn: SENTRY_DSN || 'https://35c44dbae13d4a3f8359e69c7ebba90b@o36975.ingest.sentry.io/5853766',
  integrations: [browserTracingIntegration()],
  release: process.env.SENTRY_RELEASE,
  environment: process.env.sentryEnv,
  tracesSampleRate: 0.1,
  ignoreErrors: [
    // extensions
    'top.GLOBALS', // Random plugins/extensions
    'runtime.sendMessage()', // some extensions
    'Not implemented on this platform', // safari extension https://github.com/WordPress/openverse/issues/524
    'UET is not defined', // caused by adblocker blocking bat.bing.com
    "Can't find variable: UET", // caused by adblocker blocking bat.bing.com
    'There is no clipping info for given tab', // Evernote Web Clipper
    // browser bugs
    'PerformanceObserverInit.entryTypes', // safari 13.1 random bug
    '__gCrWeb', // chrom-mobile bugs https://bugs.chromium.org/p/chromium/issues/list?q=__gCrWeb&can=2
    'NS_ERROR_FAILURE', //firefox internal issues
    // google analytics
    'Event `CustomEvent` (type=unhandledrejection) captured as promise rejection', // likely caused by Google Publisher Tag
    "Can't find variable: fbq", // caused by Google Tag Manager
    'fbq is not defined', // caused by Google Tag Manager
    'getRestrictions', // caused by Google Tag Manager
    'google_tag_manager',
    'this.clear is not a function', // replacer inside gtm.js
    //external sources
    "reading 'M_ID'", // injected executors/*.js script (extension/adware)
    "reading 'p8'", // recaptcha internals
    "Identifier 'nativeIframe' has already been declared", // injected script
    'Error invoking postEvent', // Telegram in-app webview
    'update the registered URL on your CookieYes account', // CookieYes on unregistered (preview) domains
    '.className.toLowerCase is not a function', // clarity
    'AF_SMART_SCRIPT', // onelink scripts
    'generateOneLinkURL', // onelink scripts
    'No currency found!', // puppeteer
    'didTimeout', //recaptcha
    'podscribe',
    'profitwell',
    // unknown sources
    "null is not an object (evaluating 'e.location')", //something external
    'Object captured as promise rejection with keys', //something external
    'contentWindow.postMessage', //something external
    'WKWebView', //something external
    // unknown things
    'Non-Error promise rejection captured', // no data to fix
    'PromiseRejectionEvent', // no data to fix
    'Non-Error exception captured', // no data to fix
    'The operation is insecure.', // no data to fix
    '<unknown>', // no data to fix
    'Error: db', // no data to fix
    // to revisit occasionally
    'localStorage', // atm we don't use it
    'Failed to connect to MetaMask', // some crypto extention
    'Failed to fetch (ad.doubleclick.net)', // adblocker blocking things
  ],
  // report only errors originating from our own scripts, 3rd party scripts (GTM, pixels, widgets) are ignored
  denyUrls: [
    /chrome:\/\//,
    /moz-extension/,
    /chrome-extension/,
    /safari-extension/,
    /safari-web-extension/,
    /webkit-masked-url/, // safari
    /gtag\/js/, // google analytics
    /googletagmanager\.com/, // google tag manager
    /\/executors\/\d+\.js/, // injected extension/adware scripts
  ],
});

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
